import { render, staticRenderFns } from "./PriceToolTip.vue?vue&type=template&id=aee90284&scoped=true"
import script from "./PriceToolTip.vue?vue&type=script&setup=true&lang=ts"
export * from "./PriceToolTip.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PriceToolTip.vue?vue&type=style&index=0&id=aee90284&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee90284",
  null
  
)

export default component.exports